import { SWRConfig } from 'swr';
import { PARAM_API } from './axios';

const fetcher = (url) => PARAM_API.get(url).then(res => res.data);

const ConfigSWR = (props) => {

    const {children} = props;


    return (
        <SWRConfig 
        value={{
          fetcher: fetcher
        }}
      >
        {children}
      </SWRConfig>
    )

}

export default ConfigSWR;